const HTTP_BASE_URL = "https://carcrmapi.anlyst.com/api/";
//
export default HTTP_BASE_URL;
